import clsx from 'clsx';
import { Children, ComponentProps, ReactNode } from 'react';

import { ViewVariant } from '~modules/media-library/model/ViewVariant';
import { LoadMoreTrigger } from '~modules/media-library/view/List/LoadMoreTrigger';
import { isLessThanMedium, isLessThanSmall } from '~utils/browser';

type ListProps = Resolve<
  ComponentProps<typeof LoadMoreTrigger> & {
    children: ReactNode;
    count: number;
    viewVariant: ViewVariant;
    className?: string;
  }
>;

export function List({ children, count = 0, onLoadMore, viewVariant, className = '' }: ListProps) {
  // Derived values
  const countChildren = Children.count(children);
  const hasMore = countChildren < count;

  return (
    <div className={clsx('ml--list bg-gray', className)}>
      <div
        className={clsx(
          'ml--list-items relative gap-3 py-3 mx-auto max-w-screen-xl',
          viewVariant === ViewVariant.LIST ? 'flex flex-col' : 'grid',
          isLessThanSmall()
            ? {
                'grid-cols-2': viewVariant === ViewVariant.TILE_MEDIUM,
                'grid-cols-3': viewVariant === ViewVariant.TILE_SMALL,
              }
            : isLessThanMedium()
            ? {
                'grid-cols-2': viewVariant === ViewVariant.TILE_LARGE,
                'grid-cols-3': viewVariant === ViewVariant.TILE_MEDIUM,
                'grid-cols-4': viewVariant === ViewVariant.TILE_SMALL,
              }
            : {
                'grid-cols-3': viewVariant === ViewVariant.TILE_LARGE,
                'grid-cols-4': viewVariant === ViewVariant.TILE_MEDIUM,
                'grid-cols-6': viewVariant === ViewVariant.TILE_SMALL,
              },
        )}
      >
        {children}
      </div>
      {hasMore && <LoadMoreTrigger onLoadMore={onLoadMore} />}
    </div>
  );
}
